/** @flow */
import type { State } from "@store/reducers";
import type {
  MedicalTriageType,
  SettingTheSceneType,
  PastMedicalHistoryType,
  MedicationType,
  AllergyType,
  AssessmentOutcomePartType,
  LifestyleAdviceType,
  SymptomAdviceType,
  ClassificationType,
} from "../types";

export const getSettingTheScene = (state: State): ?SettingTheSceneType =>
  state.recording.triage.settingTheScene;

export const getMedicalTriage = (state: State): ?MedicalTriageType => state.recording.triage.triage;

export const getPastMedicalHistory = (state: State): Array<PastMedicalHistoryType> => {
  return state.recording.triage.medicalHistory.content;
};

export const getCurrentMedications = (state: State): Array<MedicationType> => {
  return state.recording.triage.medications.content;
};

export const getCurrentAllergies = (state: State): Array<AllergyType> => {
  return state.recording.triage.allergies.content;
};

export const getAssessmentOutcome = (state: State): ?AssessmentOutcomePartType => {
  return state.recording.triage.assessment.outcome;
};

export const getAssessmentSymptoms = (state: State): ?Array<SymptomAdviceType> => {
  return state.recording.triage.assessment.symptoms;
};

export const getLifestyleAdvices = (state: State): Array<LifestyleAdviceType> => {
  return state.recording.triage.advice.lifestyle.lifestyleAdviceGiven;
};

export const getClassification = (state: State): ?ClassificationType => {
  return state.recording.triage.classification.content;
};

export const getClassificationSchema = (state: State): ?Object => {
  return state.recording.triage.classification.schema;
};
